import axios, { AxiosInstance } from 'axios';
import { Endpoints } from '../endpoints';

export interface GetPhysicianBalancesRequest {
  physicianName: string;
  licenseNumber: string;
}

export interface PhysicianBalance {
  fullName: string;
  licenseNumber: string;
  physicianId: number;
  statusId: number;
  amountDue: string;
  pendingPaymentStatus: string;
  legalCanPay: boolean;
}

export const getPhysicianBalances = async (
  params: GetPhysicianBalancesRequest,
  instance: AxiosInstance = axios,
) => {
  return instance.get<PhysicianBalance[]>(Endpoints.Physician.GET_BALANCES, {
    params,
  });
};

export const getPhysician = async (id: number, instance: AxiosInstance = axios) => {
  return instance.get<PhysicianBalance>(Endpoints.Physician.GET_BALANCE.replace('{id}', `${id}`));
};

export interface PaymentItem {
  licenseNumber: string;
  name: string;
  amount: number;
}

export const getPaymentPageToken = async (
  items: PaymentItem[],
  instance: AxiosInstance = axios,
) => {
  return instance.post<{ token: string }>(Endpoints.Physician.PAYMENT_PAGE, { items });
};
